import fichaClinicaService from '@/services/fichaClinica'

const initialState = () => ({
  idAso: null,
  perguntas: [],
  respostas: {},
  agendamento: {},
  hashAssinatura: null
})

const state = initialState()

const getters = {
  perguntasPorTipo: state => id => {
    return state.perguntas.filter(pergunta => id ? pergunta.categoria.id === id : true) 
  }
}

const mutations = {
  RESET: state => {
    Object.assign(state, initialState())
  },
  SET_ID_ASO: (state, idAso) => {
    state.idAso = idAso
  },
  SET_PERGUNTAS: (state, perguntas) => {
    state.perguntas = perguntas
  },
  SET_RESPOSTAS: (state, respostas) => {
    state.respostas = respostas
  },
  SET_AGENDAMENTO: (state, agendamento) => {
    state.agendamento = agendamento
  },
  SET_HASH_ASSINATURA: (state, hashAssinatura) => {
    state.hashAssinatura = hashAssinatura
  }
}

const actions = {
  preparaFichaClinica: async ({ commit, dispatch }, aso) => {
    const { idAso, tipo } = aso

    commit('SET_ID_ASO', idAso)
    commit('SET_AGENDAMENTO', aso)

    try {
      const { data } = await fichaClinicaService.getPerguntasAndRespostas(tipo.toLowerCase())
      const { perguntas, respostas, hashAssinatura } = data

      commit('SET_PERGUNTAS', perguntas)
      commit('SET_RESPOSTAS', respostas)
      commit('SET_HASH_ASSINATURA', hashAssinatura)

      return true
    } catch (error) {
      console.log(error)
      dispatch('app/showErrorMessage', error.response.data.message, {
        root: true
      })

      return false
    }
  },
  finalizarFichaClinica: async ({ state, dispatch }) => {
    const { idAso, respostas } = state

    try {
      await fichaClinicaService.finalizarFichaClinica({
        idAso,
        respostas
      })
      return true
    } catch (error) {
      dispatch('app/showErrorMessage', error.response.data.message, {
        root: true
      })

      return false
    }
  }
}

export default { namespaced: true, state, getters, mutations, actions }
